import { Component, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  standalone: false,
  selector: 'app-confirm-cancel-modal',
  templateUrl: './confirm-cancel-modal.component.html',
  styleUrls: ['./confirm-cancel-modal.component.scss']
})
export class ConfirmCancelModalComponent {
  @ViewChild('confirmCancelModal') modal: ElementRef;

  constructor(private router: Router) { }

  open() {
    this.modal.nativeElement.open = true;
  }

  close() {
    this.modal.nativeElement.open = false;
  }

  onProceed() {
    this.close();
    this.router.navigate(['/home']);
  }
}
